import { FaArrowRight } from "react-icons/fa";
import PropTypes from 'prop-types'
import { Link } from "react-router-dom";
import SearchIcon from "./searchIcon";
const BtnApply = ({css,text="apply now", isScroll}) => {
    const link = 'https://apply.uniten.edu.my/uniapps/'
    return (
        <div className="flex items-center gap-3">
            <Link to={link} className={`w-26 h-fit p-1 px-3 group text-xs 2xl:text-lg font-normal capitalize  whitespace-nowrap rounded-sm border  flex justify-center items-center gap-1 ${css ? css : "border-white text-white"}`}>
                {text}
                <FaArrowRight className="group-hover:translate-x-1 transition-transform "  />
            </Link>
            <SearchIcon isScroll={isScroll} />
        </div>

    )
}
BtnApply.propTypes ={
    css: PropTypes.string,
    text: PropTypes.string
}
export default BtnApply